<template>
  <div v-loading="loading">
    <div class="alert alert-primary" role="alert" v-if="!actual_chat">Seleccione un chat en la lista</div>

    <div class="card" v-if="actual_chat">
      <div class="card-header">Chat con {{ actual_chat.chat.sender }}</div>
      <div class="card-body">
        <div
          style="height: calc(100vh - 360px); overflow-x: auto;"
          v-chat-scroll="{smooth: true, notSmoothOnInit: true}"
        >
          <div v-for="(message, index) in actual_chat.messages" :key="index">
            <!-- FOR SENDER -->
            <div
              class="d-flex"
              :class="[message.sender ? 'justify-content-start' : 'justify-content-end']"
            >
              <div
                class="alert"
                :class="[message.sender ? 'alert-primary' : 'alert-success']"
                role="alert"
              >
                <strong>{{ message.name }} dice:</strong>
                <p>{{ message.message }}</p>
                <div class="text-right text-muted">
                  <small>{{ message.created_at | moment("DD/MM HH:mm") }}</small>
                </div>
              </div>
            </div>
          </div>
          <!-- END FOR -->
        </div>
        <!-- End Messages -->
        <sender-message></sender-message>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import SenderMessage from "./sender_message";

export default {
  components: {
    SenderMessage,
  },
  computed: {
    ...mapState({
      loading: (state) => state.Chat.loading,
      actual_chat: (state) => state.Chat.actual_chat,
    }),
  },
};
</script>

<style>
</style>